export { default } from './Consent';
